import { ApButtonMain } from '@alixpartners/ui-components';
import React from 'react';

import { Wrapper, ImageContainer, Title, Text } from './NoData.styles';

export const NoData = ({ title, msg, onResetClick }) => (
	<Wrapper>
		<ImageContainer />

		<Title>{title}</Title>
		<Text>{msg}</Text>
		<ApButtonMain
			autoFocus={false}
			disabled={false}
			iconName="baseline_undo"
			iconProps={{
				iconColor: '#ffffff',
			}}
			theme="light"
			onClick={onResetClick}
		>
			Reset filters
		</ApButtonMain>
	</Wrapper>
);

export default NoData;
